export default __webpack_public_path__ + "static/media/0_upper_left.4395405f.svg";